/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects'
import getSocioStatGeneralActions, {
    getSocioStatGeneralTypes,
} from '../../../redux/donneesSocioEconomique/getStatGeneral'
import { Get } from '../../../serveur/axios'

function* getSocioStatGeneralSagas({ response }) {
    const { governorate, year, yearSecondary } = response

    let url = 'editique/socio_economic/statistique_general?'

    if (governorate) {
        url = `${url}&gouvernorat=${governorate}`
    }
    if (year) {
        url = `${url}&year=${year}`
    }
    if (yearSecondary) {
        url = `${url}&yearSecondary=${yearSecondary}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getSocioStatGeneralActions.getSocioStatGeneralSuccess(res)
                ),
            ])
        } else {
            yield put(
                getSocioStatGeneralActions.getSocioStatGeneralFailure(res)
            )
        }
    } catch (error) {
        yield put(getSocioStatGeneralActions.getSocioStatGeneralFailure(error))
    }
}

export function* getSocioStatGeneralSaga() {
    yield takeLatest(
        getSocioStatGeneralTypes.GET_SOCIO_STAT_GENERAL_REQUEST,
        getSocioStatGeneralSagas
    )
}
